<template>
  <el-dialog title="提示" :visible.sync="isShow">
     <span class="tips-msg">您当前使用的是IE浏览器,为了您更好的浏览体验，我们建议您使用以下浏览器。</span>
     <span class="tips-bw"><a href="https://www.microsoft.com/zh-cn/edge"><img class="browse-icon" src="static/images/Edge.png"/>Microsoft Edge</a></span>
     <span class="tips-bw"><a href="https://www.google.cn/chrome/"><img class="browse-icon" src="static/images/chrome.png" />Google Chrome</a></span>
  </el-dialog>
</template>
<script>
export default {
  data: () => {
    return {
      isShow: false
    };
  },
  methods: {
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted () {
    this.isShow = this.isIE()
  }
};
</script>
<style scoped>
.tips-msg {
  display: block;
  margin-bottom: 20px;
}
.browse-icon {
  width: 40px;
  display: inline-block;
}
.tips-bw {
  margin-right: 40px;
}
.dialog {
  text-align: center;
  height: max-content;
  position: fixed;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
  width: 500px;
  z-index: 999;
  font-size: 16px;
}
.msg-box{color: #480404;}
</style>



// WEBPACK FOOTER //
// src/views/components/ieTips.vue